
export default {
  props: {
    boleto: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    viewBoleto() {
      window.open(this.boleto.urlBoleto, '_blank')
    },
  },
}
